<div class="p-grid" style="margin: 15px;">
    <div class="p-col-12">

        <!-- FILTRE ENTETE -->
        <p-header>
          <!--   SECTION Volumetrie -->
          <div class="p-grid">
            <div class="p-col-12 p-lg-4 p-xl-2">
              <p-dropdown  [style]="{'width':'100%'}" [options]="typeFicheChoice" [(ngModel)]="chooseType"  appendTo="body" placeholder="Choix type de fiche"></p-dropdown>
            </div>

            <div class="p-col-12 p-lg-4 p-xl-2">
              <p-dropdown  [style]="{'width':'100%'}" [options]="userChoice" [(ngModel)]="choosenPers" [disabled]="!canSelectUser" appendTo="body" placeholder="Choisissez une personne"></p-dropdown>
            </div>

            <div class="p-col-12 p-lg-4 p-xl-2">
              <p-dropdown  [style]="{'width':'100%'}" [options]="perfChoice" [(ngModel)]="perfValue" appendTo="body" placeholder="Choisissez une option"></p-dropdown>
            </div>


            <!--   SECTION DATE -->
            <div class="p-col-12 p-md-6 p-lg-6 p-xl-4">
              <button class="ui-fluid search" pButton [iconPos]="'right'" style="width: 100%; background-color: antiquewhite; border-color: antiquewhite; color:black; font-weight: bold;" icon="pi pi-calendar" label="Calendrier"  (click)="dateOverlay.toggle($event)"></button>
              <p-overlayPanel #dateOverlay [appendTo]="'body'">
                <p-tabView  [(activeIndex)]="activeIndexTabView">
                  <p-tabPanel header="Jour">
                    <p-calendar [(ngModel)]="valueDate" [inline]="true" dateFormat="yy-mm-dd" styleClass="yourClass" [locale]="fr"></p-calendar>
                  </p-tabPanel>
                  <p-tabPanel header="Semaine">
                    <p-calendar [(ngModel)]="valueSemaine" [inline]="true" selectionMode="range"
                                (onSelect)="selectRangeWeek($event)" dateFormat="yy-mm-dd" [yearNavigator]="true" [showWeek]="true" yearRange="2000:2030" [locale]="fr"></p-calendar>
                  </p-tabPanel>
                  <p-tabPanel header="Mois">
                    <p-calendar [(ngModel)]="valuMois" [inline]="true" view="month" dateFormat="yy-mm" [yearNavigator]="true" yearRange="2000:2030" [locale]="fr"></p-calendar>
                  </p-tabPanel>
                  <p-tabPanel header="Periode">
                    <p-calendar [(ngModel)]="valuePeriode" [inline]="true" selectionMode="range"
                                dateFormat="yy-mm-dd" [yearNavigator]="true" [showWeek]="true" yearRange="2000:2030" [locale]="fr"></p-calendar>
                  </p-tabPanel>
                </p-tabView>
              </p-overlayPanel>
            </div>
            
            <!--   SECTION BOUTTON AFFICHER -->
            <div class=" p-col-12 p-md-6 p-lg-6 p-xl-2">
              <p-button class="ui-fluid search" [iconPos]="'right'" style="width: 100%;" icon="pi pi-search" label="Afficher" (onClick)="getDataFromDate()"></p-button>
            </div>
          </div>
        </p-header>
    </div>

    <div class="p-col-12">
      <div class="p-col-12 p-md-6 p-lg-6 p-xl-2">
        <p-button class="ui-fluid search" [iconPos]="'right'" style="width: 100%;" icon="pi pi-file-excel" label="Export" (onClick)="exportListeFiches()"></p-button>
      </div>
      
    </div>

    <div class="p-col-12" style="overflow-x: auto;">
      <div class="p-grid" style="min-width: 1400px;">
        <div class="p-col-3">  
          <p-panel  styleClass="card">
              <p-header class="center-header">
                Nbre fiches traitées/complexité
              </p-header>
              
              <p>
                  <p-chart [data]="barData" [height]="'310'" type="bar" [options]="nbTraiteesOptions"></p-chart>
              </p>

              <p-footer>
                Nombre total : {{nbTotal}} 
              </p-footer>
          </p-panel>
        </div>

        <div class="p-col-3">
          <p-panel  styleClass="card" class='dmt-moyenne'>
            <p-header class="center-header">
              DMT moyenne/complexité
            </p-header>
            
            <div class="p-grid">
              <div class="p-col-12">
                <div style="width: 100%;text-align: center;">Réelle</div>
                <ul>
                  <li>Faible  : {{dmtMoyenne.faible}} </li>
                  <li>Moyenne : {{dmtMoyenne.moyenne}} </li>
                  <li>Forte   : {{dmtMoyenne.forte}} </li>
                </ul>
              </div>
              <div class="p-col-12">
                <div style="width: 100%;text-align: center;">Objective</div>
                <ul>
                  <li>Faible  : 01:27 </li>
                  <li>Moyenne : 02:46 </li>
                  <li>Forte   : 04:55 </li>
                </ul>
              </div>
            </div>

            <p-footer></p-footer>
          </p-panel>
        </div>

        <div class="p-col-3">
            <p-panel  styleClass="card">
                <p-header class="center-header">
                  Gain/perte de temps
                </p-header>
                
                <div class="center-number" [class]=" (gainPerteColor !== 0) ?  ((gainPerteColor === 1) ? 'number-green' : 'number-red')  : '' " >
                    {{gainPerte}}
                </div>

                <p-footer></p-footer>
            </p-panel>
        </div>

        <div class="p-col-3">
            <p-panel  styleClass="card">
                <p-header class="center-header">
                  Qualité ISO
                </p-header>
                
                <div style="text-align: center; margin-bottom: 7px;">
                    {{(tauxIso) ? tauxIso : 0}}%
                </div>
                <div>
                    <p-chart type="doughnut" [data]="qualite" [options]="options" [height]="'270'"></p-chart>
                </div>

                <p-footer></p-footer>
            </p-panel>
        </div>
      </div>
    </div>

    <div class="p-col-12" style="overflow-x: auto;">
      <div class="p-grid" style="min-width: 1400px;">
        <div class="p-col-3">
          <p-panel  styleClass="card" class='dmt-moyenne'>
              <p-header class="center-header">
                Durée réelle totale de traitement
              </p-header>
              
              <div class="p-grid">
                <div class="p-col-12">
                  <div style="width: 100%;text-align: center;">Durée réelle</div>
                  <ul>
                    <li>Faible  : {{dureeParComplexite.dureeFaible}}  ({{dureeParComplexite.totalFaible}} fiches)</li>
                    <li>Moyenne : {{dureeParComplexite.dureeMoyenne}}  ({{dureeParComplexite.totalMoyenne}} fiches)</li>
                    <li>Forte   : {{dureeParComplexite.dureeForte}}  ({{dureeParComplexite.totalForte}} fiches)</li>
                  </ul>
                </div>
                <div class="p-col-12">
                  <div style="width: 100%;text-align: center;">Cadence réelle</div>
                  <ul>
                    <li>Faible  : {{cadence.faible}}  </li>
                    <li>Moyenne : {{cadence.moyenne}}  </li>
                    <li>Forte   : {{cadence.forte}}  </li>
                  </ul>
                </div>
              </div>

              <p-footer></p-footer>
          </p-panel>
        </div>
      </div>
    </div>

</div>
